/**
 * Тексты, которые видит пользователь, когда сервер не ответил.
 *
 * Сообщения самого сервера уже приходят по-русски (единый формат ошибки),
 * поэтому здесь только то, что случается до ответа.
 */

export const API_ERROR_MESSAGES = {
  network: "Сервер не отвечает. Проверьте подключение и повторите",
} as const;
